import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=19019ade"
import script from "./menu.vue?vue&type=script&lang=ts"
export * from "./menu.vue?vue&type=script&lang=ts"
import style0 from "./menu.vue?vue&type=style&index=0&id=19019ade&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports